module.exports = __webpack_public_path__ + "img/technology-icon-1.c0b43e02.png";